import { API_ROOT } from '../Configuration/environments';
const url_api = API_ROOT;//process.env.REACT_APP_API_URL;

class UserService {


    async getUserInfo(nsuid, dob) {


        var nsuidbase64 = btoa(`${nsuid}`);
        var dobbase64 = btoa(`${dob}`);

        let userinfo = {
            PassportPhone: nsuidbase64,
            DOB: dobbase64
        };

        var url = url_api + `user/userinfoInternational`;

        return fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(userinfo),
        })

            .then(response => {

                if (!response.ok) {

                    return this.handleResponseError(response);

                }

                return response.json();

            })
            .then(item => {

                return item;

            });

    }

    async getCellphoneValidation(cellphone) {

        var url = url_api + `user/userinfoInternational/phone/${cellphone}`;

        return fetch(url, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })

            .then(response => {

                if (!response.ok) {

                    return this.handleResponseError(response);

                }

                return response.json();

            })
            .then(item => {

                return item;

            });
    }

    async getpassportValidation(passport) {

        var url = url_api + `user/userinfoInternational/passport/${passport}`;

        return fetch(url, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })

            .then(response => {

                if (!response.ok) {

                    return this.handleResponseError(response);

                }

                return response.json();

            })
            .then(item => {

                return item;

            });
    }

    async getDOBValidation(dob) {

        var url = url_api + `user/userinfoInternational/dob/${dob}`;

        return fetch(url, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })

            .then(response => {

                if (!response.ok) {

                    return this.handleResponseError(response);

                }

                return response.json();

            })
            .then(item => {

                return item;

            });
    }


    handleResponseError(response) {
        console.log(response);

        return response.text().then(function (text) {

            return JSON.parse(text).message;

        }).then(function (error) {

            console.log(error);
            throw new Error(error);

        });
    }

}

export default UserService;